module.exports = __webpack_public_path__ + "static/media/icon-iheartradio.e025c3ca.svg";